module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_pepita_pama.0c99cb7f.pdf";